import * as React from "react";
import Select from "react-select";

import Money from "web_modules/Money";
import LabeledInput from "web_modules/LabeledInput";
import { addressToStr } from "@eave/shared/utils/addresses";

const { Panel } = require("react-bootstrap");
const humanize = require("underscore.string/humanize");

interface IRentalIncomeSectionProps {
  ownedDocs: any[];
  taxReturns: any[];
  property: any;
  setOwnedRealEstateScheduleEPropertyLabel: Function;
  propertyLabelAndAddressOptions: Function;
  propertyLabelAndAddressOptionSelected: Function;
  setDocId: Function;
  onChange: Function;
}

class RentalIncomeSection extends React.Component<IRentalIncomeSectionProps, any> {
  constructor(props) {
    super(props);
  }

  handleSelectChange(field, e) {
    this.props.onChange(field, e.hasOwnProperty("value") ? e.value : "");
  }

  handleChange(e) {
    this.props.onChange(e.target.name, e.target.value);
  }

  render() {
    const {
      ownedDocs,
      taxReturns,
      property,
      setDocId,
      setOwnedRealEstateScheduleEPropertyLabel,
      propertyLabelAndAddressOptions,
      propertyLabelAndAddressOptionSelected,
    } = this.props;
    return (
      <Panel defaultExpanded>
        <Panel.Body>
          <div className="income_doc_other_income_summary">
            <dl className="dl-horizontal income_doc_employment_summary__addresses">
              <dt>Address</dt>
              <dd>
                {addressToStr(
                  property.operator_address_line1 || property.address_line1,
                  property.operator_address_line2 || property.address_line2,
                  property.operator_city || property.city,
                  property.operator_state || property.state,
                  property.operator_postal_code || property.postal_code,
                )}
              </dd>
              <dt>Disclosed Address</dt>
              <dd>
                {addressToStr(
                  property.address_line1,
                  property.address_line2,
                  property.city,
                  property.state,
                  property.postal_code,
                )}
              </dd>
              <dt>Disclosed Monthly Lease Amount</dt>
              <dd>
                <Money value={property.monthly_rental_income || 0} />
              </dd>
            </dl>
            <dd>
              <table className="income_documents_review__tax-returns-table">
                <thead>
                  <tr>
                    <th>Source</th>
                    <th>Schedule E Label - Address</th>
                    <th>Tax Year</th>
                  </tr>
                </thead>
                <tbody>
                  {taxReturns.map(doc => (
                    <tr key={doc.id}>
                      <td>
                        <span>
                          <a onClick={setDocId.bind(this, doc.id)}>
                            {doc.display_text || humanize(doc.type)} [ID: {doc.id}]
                          </a>
                          <br />
                        </span>
                      </td>
                      <td>
                        <Select
                          clearable
                          placeholder="Select Property Label..."
                          value={propertyLabelAndAddressOptionSelected(property.id, doc)}
                          options={propertyLabelAndAddressOptions(doc)}
                          onChange={setOwnedRealEstateScheduleEPropertyLabel.bind(
                            this,
                            property.id,
                            doc.id,
                          )}
                        />
                      </td>
                      <td>
                        {
                          // year is last 4 of tax return doc type
                          doc.type.slice(-4)
                        }
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </dd>
            <dt>Additional Source(s)</dt>
            <dd>
              {ownedDocs.map(doc => (
                <span key={doc.id}>
                  <a onClick={setDocId.bind(this, doc.id)}>
                    {doc.display_text || humanize(doc.type)} [ID: {doc.id}]
                  </a>
                  <br />
                </span>
              ))}
            </dd>
            <LabeledInput
              inputType="textarea"
              inputName="notes"
              labelValue="Notes"
              inputValue={this.props.property.notes}
              onChange={this.handleChange.bind(this)}
            />
          </div>
        </Panel.Body>
      </Panel>
    );
  }
}

export default RentalIncomeSection;
